<div
  class="mat-dialog-style w-100 d-flex flex-column align-items-center justify-content-center"
>
  <div class="error-modal-icon mb-3">
    <img 
    src="assets/images/warning_icon.svg" 
    alt="warning" 
    loading="lazy"
    fetchpriority="high"
     />
  </div>
  <div class="content-style" mat-dialog-content>
    <div class="error-content">
      <p class="text-center">
        {{ errorMsg || "error.dept-error" | translate }}
      </p>
    </div>
  </div>
  <div class="text-center">
    <button mat-button (click)="errorDialogRef.close()" class="btn btn-primary">
      {{ "buttons.close" | translate }}
    </button>
  </div>
</div>
